import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { Provider } from "react-redux";
import { persistor, store } from "./redux/store.ts";
import { PersistGate } from "redux-persist/integration/react";
import { router } from "./routes/routes.tsx";
import { RouterProvider } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { NotificationProvider } from "./context/NotificationContext.tsx";
import { ToastProvider } from "./components/ui/ToastContext.tsx";
import * as Sentry from "@sentry/react";
import RootErrorBoundary from "./components/common/ErrorBoundary.tsx";
import { GlobalContextProvider } from "./context/GlobalContext.tsx";
import { ConfirmationProvider } from "./context/ConfirmationContext/ConfirmationContext.tsx";
import TourGuide from "./components/ui/tourGuide/TourGuide.tsx";
import AuthBootSplash from "./components/common/AuthBootSplash.tsx";
if (import.meta.env.VITE_NODE_ENV === "production") {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_NODE_ENV,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/passionbits\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={<AuthBootSplash />} persistor={persistor}>
        <RootErrorBoundary>
          <ToastProvider>
            <GlobalContextProvider>
              <NotificationProvider>
                <ConfirmationProvider>
                  <Toaster reverseOrder={false} />
                  <RouterProvider router={router}></RouterProvider>
                </ConfirmationProvider>
              </NotificationProvider>
            </GlobalContextProvider>
          </ToastProvider>
        </RootErrorBoundary>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
);
